export default __webpack_public_path__ + "static/media/89d7a77c747212ca18cc2bc3812994571581617833053.3c8ff8fd.webp";